/**
 * @fileoverview GET handler for the "/:app_group_id/campaign_qa_runs/:campaign_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { campaignQaRun } from "./constants";
import type { GetCampaignQaRunProps, GetCampaignQaRunResult } from "./types";
import { isGetCampaignQaRunResult } from "./validators";

export const getCampaignQaRun = reactQueryFetcherAdapter(
  campaignQaRun,
  (signal: AbortSignal, { appGroupId, campaignId }: GetCampaignQaRunProps): Promise<GetCampaignQaRunResult> => {
    return fetch(
      `/${appGroupId}/campaign_qa_runs/${campaignId}`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetCampaignQaRunResult
);
